import Foundation from './modules/foundation';
import Carousel from './modules/carousel';
import AOS from './modules/aos';
import Magnific from './modules/magnific';
import Header from './modules/header';

$(document).ready(() => {
    Foundation.setup();
    AOS.setup();
    Magnific.setup();
    Header.setup();

    const searchToggle = document.querySelector(".search__toggle")
    const searchDiv = document.querySelector(".header__search")
    if (searchToggle) {
        searchToggle.addEventListener("click", () => {
            searchDiv.classList.toggle("header__search--active")
        })
    }


    // stops scrolling when hamburger menu is active
    const offCanvas = document.querySelector(".off-canvas")
    const offCanvasWrapper = document.querySelector(".off-canvas-wrapper")

    const onMenuToggle = () => {
        if (offCanvas.classList.contains("is-open")) {
            const x = window.scrollX
            const y = window.scrollY
            window.onscroll = () => window.scrollTo(x, y)
        } else {
            window.onscroll = () => {}
        }
    }

    const mutationObserver = new MutationObserver(onMenuToggle)
    mutationObserver.observe(offCanvas, {
        attributes: true
    })

    Carousel.setup('.banner__slider', {
        delay: true,
        prevArrow: '<i class="fal fa-chevron-left"></i>',
        nextArrow: '<i class="fal fa-chevron-right"></i>',
        arrows: true,
    });



    Carousel.setup('.product__imageNav', {
        prevArrow: '<i class="fal fa-chevron-left"></i>',
        nextArrow: '<i class="fal fa-chevron-right"></i>',
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        cssEase: 'ease-out',
    });

    $('.product__imageSingle').on('afterChange', function (event, slick, currentSlide) {
        $('.product__imageNav').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.product__imageNav .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.product__imageNav .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('.product__imageNav').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');

        $('.product__imageSingle').slick('slickGoTo', goToSingleSlide);
    });

    /**
     * Add Sliders below 
     */
    Carousel.setup('.review__slider', {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        cssEase: 'ease-out',
        speed: 500,
        autoplay: true,
        responsive: [{
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                }
            }
        ]
    });
    Carousel.setup('.logo__slider', {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        cssEase: 'ease-out',
        speed: 500,
        arrows: false,
        responsive: [{
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            }
        ]
    });
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function (active) {
            this.classList.toggle("active");

            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }
  

});